import {
  APPROVAL_LIST_COUNT_ERROR,
  APPROVAL_LIST_ERROR,
  CLEAR_SUBMIT_APPROVAL_ACTION_ERROR,
  CLOSE_APPROVAL_ACTION_MODAL,
  OPEN_APPROVAL_ACTION_MODAL,
  SET_ACTION,
  SET_APPROVALS_FORM,
  SET_APPROVALS_LIST,
  SET_APPROVALS_LIST_COUNT,
  SET_APPROVALS_PENDING,
  SET_PAGE_SIZE_GLOBAL,
  SET_SELECTED_REQUEST_ID,
  SUBMIT_APPROVAL_ACTION_ERROR,
  SUBMIT_APPROVAL_ACTION_PENDING,
  SUBMIT_APPROVAL_ACTION_SUCCESS,
} from "../approvals/actionTypes";

const initialState = {
  //-------------------------------APPROVAL-LIST------------------------------------------
  isGetApprovalsPending: false,
  approvals: [],
  approvalListCount: 0,
  approvalListError: null,
  //-------------------------------APPROVAL-ACTIONS---------------------------------------
  action: null,
  selectedId: null,
  isApprovalActionModalOpen: false,
  isPending: false,
  errorMessage: null,
  approvalsForm: {},

  pageSizeGlobal: 0,
};

export default (localState = initialState, action) => {
  switch (action.type) {

    case SET_PAGE_SIZE_GLOBAL: {
      const { pageSize } = action.payload;
      return {
        ...localState,
        pageSizeGlobal: pageSize
      };
    }

    //-------------------------------APPROVAL-LIST------------------------------------------
    case SET_APPROVALS_PENDING: {
      return {
        ...localState,
        isGetApprovalsPending: true,
      };
    }
    case SET_APPROVALS_LIST: {
      const { approvalsOdata } = action.payload;
      return {
        ...localState,
        isGetApprovalsPending: false,
        approvalListError: null,
        approvals: approvalsOdata && approvalsOdata.value,
        totalRecords: approvalsOdata && approvalsOdata['@odata.count'],
      };
    }
    case SET_APPROVALS_LIST_COUNT: {
      const { approvalsOdata } = action.payload;
      return {
        ...localState,
        approvalListCount: approvalsOdata && approvalsOdata['@odata.count'],
      };
    }
    case APPROVAL_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        approvalListError: errorMessage,
        isGetApprovalsPending: false,
        approvals: [],
        totalRecords: 0
      };
    }
    case APPROVAL_LIST_COUNT_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        approvalListCount: 0
      };
    }

    //-------------------------------APPROVAL-ACTIONS---------------------------------------
    case SET_ACTION: {
      const { actionType } = action.payload;
      return {
        ...localState,
        action: actionType
      };
    }
    case SET_SELECTED_REQUEST_ID: {
      const { selectedId } = action.payload;
      return {
        ...localState,
        selectedId: selectedId,
      };
    }
    case SET_APPROVALS_FORM: {
      const { approvalsForm } = action.payload;
      return {
        ...localState,
        approvalsForm: approvalsForm
      };
    }
    case SUBMIT_APPROVAL_ACTION_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage,
        isPending: false,
      };
    }
    case SUBMIT_APPROVAL_ACTION_PENDING: {
      return {
        ...localState,
        isPending: true,
      };
    }
    case CLEAR_SUBMIT_APPROVAL_ACTION_ERROR: {
      return {
        ...localState,
        errorMessage: null,
      };
    }
    case OPEN_APPROVAL_ACTION_MODAL: {
      return {
        ...localState,
        isApprovalActionModalOpen: true,
        errorMessage: null,
      };
    }
    case CLOSE_APPROVAL_ACTION_MODAL: {
      return {
        ...localState,
        isApprovalActionModalOpen: false,
      };
    }

    default: {
      return localState;
    }
  }
};
